/**
 * Masonry Module
 *
 * @since 1.0.0
 */

import Masonry from 'masonry-layout'

const MasonryGrid = function () {
  var elem = document.querySelector('.js-grid')
  if (elem) {
    let msnry = new Masonry(elem, {
      // options
      itemSelector: '.js-grid-item',
      columnWidth: '.js-grid-container',
      percentPosition: true
    })
    setTimeout(() => {
      msnry.layout()
    }, 1000)
  }
}

export default MasonryGrid



// WEBPACK FOOTER //
// ./src/js/modules/MasonryGrid.js